import React from "react";
import MainState from "./context/MainContext/MainState";
import BillingContainer from "./components/BillingContainer";

const App = () => {
  return (
    <MainState>
      <BillingContainer />
    </MainState>
  );
};

export default App;
